export const LABELS_RU = {
  APP_NAME: 'Веб резюме',
  LAST_UPDATE: 'Последнее обновление',
  STATUS: 'Статус',
  LOCATION: 'Расположение',
  WORK_EXPERIENCE: 'Коммерческий опыт',
  COMPANY: 'Компания',
  WEBSITE: 'Вебсайт',
  PERIOD: 'Период',
  CAREER: 'Карьера',
  PROJECT_LIST: 'Список проектов',
  PROJECT: 'Проект',
  ENVIRONMENT: 'Окружение',
  RESPONSIBILITIES: 'Обязанности',
  KEY_CONTRIBUTIONS: 'Ключевые достижения',
  PROJECTS: 'Проекты',
  LIVE_DEMO: 'Демо',
  REPOSITORY: 'Репозиторий',
  SKILLS_MATRIX: 'Матрица навыков',
  SYSTEM_SKAN_COMPLETE: 'Сканирование системы завершено',
  CONTINUOUS_LEARNING: 'Непрерывное обучение',
  CONTACTS: 'Контакты',
  ABOUT_ME: 'Обо мне',
  STACK: 'Стек',
};
